module.exports = __webpack_public_path__ + "img/45.73023273.jpg";